import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { clearMessages, setSelectedUser } from '@/store/chat/actions';

import { selectChat } from '@/store/chat/selectors';
import { selectCurrentUser } from '@/store/users/selectors';

import classNames from 'classnames';

import styles from '../ChatsList.module.scss';

const BotElement = ({ data }) => {
  const { t } = useTranslation('chat');
  const dispatch = useDispatch();
  const { selectedUser } = useSelector(selectChat);
  const currentUser = useSelector(selectCurrentUser);

  const isActive = data?.chatId ? data?.chatId === selectedUser?.chatId : data?.botId === selectedUser?.botId;

  const handleSelectBot = () => {
    console.log('----', data);
    console.log('selectedUser', selectedUser);
    // Очищаем предыдущую историю сообщений при переключении на другого бота
    if (!isActive) {
      dispatch(clearMessages());
    }
    dispatch(setSelectedUser(data));
  };

  return (
    <div
      onClick={handleSelectBot}
      className={classNames(styles.groupElement, { [styles.groupElement_active]: isActive })}
    >
      <div className={classNames(styles.groupElement__header)}>
        <div className={classNames(styles.groupElement__box)}>
          {/* {!isTopic && <Avatar src={avatar} size={42} />} */}
          <p className={styles.groupElement__name}>{data?.botName || data?.chatName}</p>
        </div>
        {/* <p className={styles.groupElement__date}>{renderDate()}</p> */}
      </div>
      <p className={classNames(styles.groupElement__bot, { [styles.groupElement__bot_active]: isActive })}>
        {t('bot')}
      </p>
      <div className={styles.groupElement__content}>
        <div className={styles.groupElement__message}>
          {data?.lastMessage && (
            <p className={styles.groupElement__userName}>
              {data?.lastMessage?.userId === currentUser.id ? t('you') : data?.lastMessage?.user_first_name}
            </p>
          )}
          {/* {data?.lastMessage && <>{data?.lastMessage?.content ? data.lastMessage.content : renderFileText()}</>} */}
        </div>
        {/* {!!data?.notReadMessages && <div className={styles.groupElement__noRead}>{data.notReadMessages}</div>} */}
      </div>
    </div>
  );
};

export default BotElement;
